import React from "react";
import { ListPlus } from "phosphor-react";
import { InputWithSuffixFloatingLabel } from "./Shared";

export function AddItemInput({ value, onChange, onAddItem, disabled, width }) {
  return (
    <InputWithSuffixFloatingLabel
      value={value}
      label="Item name"
      id="item-add-input"
      onChange={onChange}
      suffix={
        <ListPlus
          size={16}
          weight="thin"
          color="var(--carter-secondary)"
          onClick={onAddItem}
        />
      }
      width={width}
      disabled={disabled}
    />
  );
}
